// import { UserIdleTimeOutService } from "./../../services/user-idle-time-out.service";
// import { Component, HostListener, OnInit } from "@angular/core";
// import { Router } from "@angular/router";
// import { CommonService } from "src/app/services/common.service";
// @Component({
//   selector: "app-home",
//   templateUrl: "./home.component.html",
//   styleUrls: ["./home.component.css"],
// })
// export class HomeComponent implements OnInit {
//   sMaduleId: any = 1;

//   constructor(
//     private userIdleTimerService: UserIdleTimeOutService,
//     private route: Router,
//     private commonService: CommonService,
//   ) {

//     const url = window.location.href;

//     const urlParts = url.split("/");
//     const homeIndex = urlParts.indexOf("HOME");
//     if (homeIndex !== -1 && homeIndex < urlParts.length - 2) {
//       const extractedPath = urlParts
//         .slice(homeIndex + 1, homeIndex + 3)
//         .join("/");
//       const skipPaths = [
//         "HOME/scdeDashboard"
//       ]
//       if (homeIndex !== -1 && homeIndex < urlParts.length - 2) {
//         if (skipPaths.some((path) => extractedPath.includes(path))) {
//           // ✅ Skip menu permission fetch
//         } else if (extractedPath !== "HOME/dashboard") {
//           this.commonService.menuPermissions(extractedPath);
//         }
//       } else {
//         console.log("Path not found in URL");
//       }
//       if (
//         extractedPath == "components/regForm" ||
//         extractedPath == "components/payment"
//       ) {
//       } else if (extractedPath != "HOME/dashboard") {
//         this.commonService.menuPermissions(extractedPath);
//       }
//     } else {
//       console.log("Path not found in URL");
//     }

//     const path = urlParts.slice(-2).join('/');
//     console.log(path);

//     if (path == 'components/regForm') { } else if (path != 'HOME/dashboard') {
//       this.commonService.menuPermissions(path)
//     }
//     path != 'HOME/dashboard' ? this.commonService.menuPermissions(path) : '';
//     this.commonService.menuPermissions(path);
//   }

//   ngOnInit(): void {
//     window.scrollBy(0, 100);
//     // this.logout();
//   }
//   changeRole(smID: any) {
//     this.sMaduleId = smID;
//   }
//   @HostListener("window:click")
//   @HostListener("window:keydown")
//   @HostListener("window:mousemove")
//   refreshUserState() {
//     clearTimeout(this.userIdleTimerService.userActiveTimer);
//     this.userIdleTimerService.timeoutUserActivity();
//   }
//   // logout() {
//   //   this.commonService.activateSpinner();
//   //   let value = localStorage.getItem("UserId");
//   //   let roleId = localStorage.getItem("RoleId");
//   //   let username = !localStorage.getItem("Username");
//   //   if (
//   //     value == "null" ||
//   //     value == ( 0 || "") ||
//   //     roleId == "null" ||
//   //     roleId == ( 0 || "") ||
//   //     username
//   //   ) {
//   //     this.route.navigate(["/landingPage"]);
//   //     this.clearToken();
//   //     this.commonService.deactivateSpinner();
//   //   }
//   //   this.commonService.deactivateSpinner();
//   // }
//   clearToken() {
//     this.commonService
//       .postCall("Account/ClearToken", {
//         UserID: localStorage.getItem("UserId"),
//       })
//       .subscribe((res: any) => { });
//   }
// }
import { UserIdleTimeOutService } from "./../../services/user-idle-time-out.service";
import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  sMaduleId: any = 1;

  constructor(
    private userIdleTimerService: UserIdleTimeOutService,
    private route: Router,
    private commonService: CommonService,
  ) {
    this.handleMenuPermissions();
  }

  ngOnInit(): void {
    window.scrollBy(0, 100);
  }

  private handleMenuPermissions(): void {
    const url = window.location.href;
    const urlParts = url.split("/");
    // Define paths to skip
    const skipPaths = [
      "HOME/instituteDashboard",
      "HOME/superAdminDashboard",
      "HOME/ictDashboard",
      "HOME/cdeDashboard",
      "HOME/scdeDashboard",
      "HOME/qasoDashboard",
      "HOME/rdeDashboard",
      "/HOME/dashboard",
      "components/kemisRegForm",
      "registration/schoolTransfer",
      "courseSetup/subjectCombinationApprovalView",
      "registration/addUserRegistration",
      "registration/editUserRegistration",
    ];

    // Extract the relevant path (last 2 segments or specific pattern)
    let extractedPath = this.extractPath(urlParts);

    extractedPath = extractedPath.includes('?')
      ? extractedPath.split('?')[0]
      : extractedPath;

    // Check if we should skip menu permissions
    if (this.shouldSkipMenuPermissions(extractedPath, skipPaths)) {
      // console.log('Skipping menu permissions for:', extractedPath);
      return;
    }

    // Fetch menu permissions
    // console.log('Fetching menu permissions for:', extractedPath);
    this.commonService.menuPermissions(extractedPath);
  }

  // private extractPath(urlParts: string[]): string {
  //   // Try to get HOME related path first (HOME/something)
  //   const homeIndex = urlParts.indexOf("HOME");
  //   if (homeIndex !== -1 && homeIndex < urlParts.length - 2) {
  //     // Get the next segment after HOME
  //     const nextSegment = urlParts.slice(homeIndex + 1, homeIndex + 3).join("/");
  //     if (nextSegment) {
  //       return `${nextSegment}`;
  //     }
  //   }
  //   // Fallback to last 2 segments
  //   return urlParts.slice(-2).join('/');
  // }

  private extractPath(urlParts: string[]): string {
    // Try to get HOME related path first (HOME/something)
    const homeIndex = urlParts.indexOf("HOME");

    if (homeIndex !== -1) {
      const firstSegment = urlParts[homeIndex + 1];
      const secondSegment = urlParts[homeIndex + 2];

      // If second segment exists and is NOT a number
      if (secondSegment !== undefined && isNaN(Number(secondSegment))) {
        return `${firstSegment}/${secondSegment}`;
      }

      // If second segment does not exist OR is a number
      if (firstSegment) {
        return firstSegment;
      }
    }

    // Fallback to last 2 segments
    return urlParts.slice(-2).join('/');
  }

  private shouldSkipMenuPermissions(path: string, skipPaths: string[]): boolean {
    // Check if path is exactly in skipPaths or contains any skip pattern
    return skipPaths.some(skipPath =>
      path === skipPath ||
      path.includes(skipPath) ||
      skipPath.includes(path)
    );
  }

  changeRole(smID: any) {
    this.sMaduleId = smID;
  }

  @HostListener("window:click")
  @HostListener("window:keydown")
  @HostListener("window:mousemove")
  refreshUserState() {
    clearTimeout(this.userIdleTimerService.userActiveTimer);
    this.userIdleTimerService.timeoutUserActivity();
  }

  clearToken() {
    this.commonService
      .postCall("Account/ClearToken", {
        UserID: localStorage.getItem("UserId"),
      })
      .subscribe((res: any) => { });
  }
}